import React from 'react';
import {
  Button,
  // ButtonGroup,
  Card,
  // CardBody,
  // CardImg,
  Col,
  Row
} from 'reactstrap';
import { Route } from 'react-router';
import { Link } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import { compact, pluck } from 'underscore';
import URI from 'urijs';
import cx from 'classnames';

// modules
import BS from '../../theme/Bootstrap';
import styles from './agent-card.module.scss';

// images
import notfound from './images/notfound.png';

const PHOTO_BASE_URL = '//memberphotos.naplesarea.com/';

function AgentCard({
  data,
  className,
  imageAlign = 'right',
  tag = Card,
  searchURI,
  detailURI,
  hideOffice,
  label = 'Agent',
  propertyClass
}) {
  const Tag = tag;
  const renderProps = {
    imageAlign,
    searchURI,
    detailURI,
    label,
    hideOffice,
    propertyClass
  };
  return (
    <Tag className={`${className} ${styles.agentCard}`}>
      <Row className={BS.noGutters}>
        {imageAlign === 'right' && renderDetails(data, renderProps)}
        {imageAlign === 'right' && renderImage(data, renderProps)}
        {imageAlign === 'left' && renderImage(data, renderProps)}
        {imageAlign === 'left' &&
          renderDetails(data, {
            ...renderProps,
            children: renderAdditional(data, renderProps)
          })}
      </Row>
      {imageAlign === 'right' && renderAdditional(data, renderProps)}
    </Tag>
  );
}

function renderAdditional(data, { hideOffice, searchURI, detailURI }) {
  const { office } = data;
  const officeDetailPath = URI(`/firm/${encodeURIComponent(office.id)}`)
    .search({
      searchURI,
      detailURI
    })
    .toString();
  return (
    <React.Fragment>
      {data.memberType === 'realtor' && (
        <div className={BS.mb2}>
          <label>Languages: </label>
          <span>
            {data.skills
              .filter(function (skill) {
                return skill.skillType === 'LANG';
              })
              .map(function (skill) {
                return skill.skillDesc;
              })
              .join(', ')}
          </span>
        </div>
      )}
      {data.memberType === 'realtor' && (
        <div
          className={cx(BS.mb2, BS.pb2, {
            [BS.borderBottom]: !hideOffice,
            [BS.borderBottomDashed]: !hideOffice
          })}
        >
          <label>Designations: </label>
          <span>{data.designations.trim().split(' ').join(', ')}</span>
        </div>
      )}
      {data.memberType === 'service_provider' && (
        <div
          className={cx(BS.mb2, BS.pb2, {
            [BS.borderBottom]: !hideOffice,
            [BS.borderBottomDashed]: !hideOffice
          })}
        >
          <label>Categories: </label>
          <span>{pluck(data.categories || [], 'name').join(', ')}</span>
        </div>
      )}
      {!hideOffice && (
        <React.Fragment>
          <h6>
            <Link to={officeDetailPath}>{office.company}</Link>
          </h6>
          <p>
            {compact([office.address1, office.address2]).map((address, i, allItems) => (
              <span key={i}>
                {address}
                {i < allItems.length - 1 && <br />}
              </span>
            ))}
            <br />
            {compact([compact([office.city, office.state]).join(', '), office.zip]).join(
              ' '
            )}
            <br />
            {compact([office.phone, office.phone2]).map((phone, i, allItems) => (
              <span key={i}>
                {phone}
                {i < allItems.length - 1 && <br />}
              </span>
            ))}
          </p>
        </React.Fragment>
      )}
    </React.Fragment>
  );
}

function renderDetails(
  data,
  { searchURI, detailURI, children, label, imageAlign, propertyClass }
) {
  const { memberType } = data;
  const agentDetailPath = URI(`/agent/${data.id}`)
    .search({
      searchURI,
      detailURI
    })
    .toString();

  var phoneNumber;
  switch (data.directWorkPhone) {
    case 'C':
      phoneNumber = data.cell;
      break;
    case 'H':
      phoneNumber = data.phone;
      break;
    case 'O':
      phoneNumber = data.office.phone;
      break;
    default:
      phoneNumber = data.directWorkPhone;
  }

  var website = data.website && data.website !== 'null' ? data.website : '';

  if (website) {
    try {
      website = URI(website);
      website = website.protocol(website.protocol() || 'http').toString();
    } catch (e) {
      website = undefined;
    }
  }

  return (
    <Col
      xs={6}
      className={cx({
        [BS.pl1]: imageAlign === 'left',
        [BS.pr1]: imageAlign === 'right'
      })}
    >
      <h5>
        <Link to={agentDetailPath}>{data.fullName}</Link>
      </h5>
      <p className={`${BS.mb2}`}>
        {phoneNumber && (
          <Button
            color="link"
            href={`tel://${phoneNumber}`}
            className={`${BS.p0} ${BS.textUnderline}`}
          >
            {phoneNumber}
          </Button>
        )}
        {website && (
          <React.Fragment>
            <br />
            <Button
              color="link"
              href={website}
              target="_blank"
              rel="noopener noreferrer"
              className={`${BS.p0} ${BS.textUnderline}`}
            >
              Visit Website
            </Button>
          </React.Fragment>
        )}
      </p>
      {data.email && (
        <Button
          color="link"
          href={`mailto:${data.email}`}
          className={`${BS.p0} ${BS.textUnderline}`}
        >
          Email {label}
        </Button>
      )}
      {data.email && <br />}
      <Route path={`/agent/${data.id}`}>
        {props =>
          !props.match && (
            <LinkContainer to={agentDetailPath}>
              <Button color="link" className={`${BS.p0} ${BS.mb2} ${BS.textUnderline}`}>
                View {label}
              </Button>
            </LinkContainer>
          )
        }
      </Route>
      {memberType === 'realtor' && (
        <div>
          <LinkContainer
            to={URI(`/agent/${data.id}/listings`)
              .search({
                searchURI,
                detailURI,
                propertyClass
              })
              .toString()}
          >
            <Button color="link" className={`${BS.p0} ${BS.textUnderline}`}>
              Active Listings ({data.numActiveListings + data.numActiveListingsAsSeller})
            </Button>
          </LinkContainer>
          <br />
          <LinkContainer
            to={URI(`/agent/${data.id}/listings`)
              .search({
                searchURI,
                detailURI,
                recentlySold: 1
              })
              .toString()}
          >
            <Button color="link" className={`${BS.p0} ${BS.mb2} ${BS.textUnderline}`}>
              Recently Sold (
              {data.numRecentlySoldListings + data.numRecentlySoldListingsAsSeller})
            </Button>
          </LinkContainer>
        </div>
      )}
      {children}
      {/*
      <h6>{office.company}</h6>
      <p>
        {compact([office.address1, office.address2]).map((address, i, allItems) => (
          <span key={i}>
            {address}
            {i < allItems.length - 1 && <br />}
          </span>
        ))}
        <br />
        {compact([office.city, office.state, office.zip]).join(', ')}
        <br />
        {compact([office.phone, office.phone2]).map((phone, i, allItems) => (
          <span key={i}>
            {phone}
            {i < allItems.length - 1 && <br />}
          </span>
        ))}
      </p>
      {children}
      */}
    </Col>
  );
}

function renderImage(data, { imageAlign, searchURI, detailURI }) {
  const { extended } = data;
  const photo = extended && extended.photo ? extended.photo : data.photo;
  const agentDetailPath = URI(`/agent/${data.id}`)
    .search({
      searchURI,
      detailURI
    })
    .toString();
  return (
    <Col
      xs={6}
      className={cx(BS.textCenter, {
        [BS.pr1]: imageAlign === 'left',
        [BS.pl1]: imageAlign === 'right'
      })}
    >
      <Link to={agentDetailPath}>
        <img
          src={photo ? `${PHOTO_BASE_URL}${photo}` : notfound}
          alt="Not Found"
          className={cx(BS.imgFluid, {
            [BS.b1]: !photo
          })}
          onError={e => {
            e.target.src = notfound;
            e.target.className = cx(e.target.className, BS.b1);
          }}
        />
      </Link>
    </Col>
  );
}

export default AgentCard;



// WEBPACK FOOTER //
// ./src/partials/agent-card/agent-card.js